import { CssBaseline, ThemeProvider } from '@mui/material';
import { useNavigate, useRoutes } from 'react-router-dom';
import Router from './routes/Router';
import './Global.css';
import { baselightTheme } from './theme/DefaultColors';
import { useEffect } from 'react';
import { useMain } from './views/hooks/useMain';

function App() {
  const routing = useRoutes(Router);
  const theme = baselightTheme;
  const navigate = useNavigate();

  const { setActiveBranchId, getBranch, setBranchData } = useMain();

  const getData = async (id) => {
    try {
      const res = await getBranch(id);
      if (res.statusCode === 200) {
        const data = res.data;
        if (data?.activeStatus && data?.activeStatus.toLowerCase() !== 'approved') {
          localStorage.removeItem('salon-branch');
          setActiveBranchId(null);
          setBranchData({});
          navigate('/auth/login');
          return;
        }
        setBranchData((pre) => ({ ...pre, ...data }));
      } else {
        localStorage.removeItem('salon-branch');
        navigate('/auth/login');
      }
    } catch (error) {
      localStorage.removeItem('salon-branch');
      navigate('/auth/login');
    }
  };

  useEffect(() => {
    const id = JSON.parse(localStorage.getItem('salon-branch'));
    if (id) {
      setActiveBranchId(id);
      getData(id);
    } else {
      navigate('/auth/login');
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {routing}
    </ThemeProvider>
  );
}

export default App;
